var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.749 10.98a.754.754 0 0 1 0-1.06l3.19-3.19-3.19-3.19a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.72 3.72a.75.75 0 0 1 0 1.06l-3.72 3.72c-.15.14-.34.22-.53.22s-.38-.07-.53-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.48c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75H3zM6.19 21.53l-3.72-3.72a.75.75 0 0 1 0-1.06l3.72-3.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.19 3.19 3.19 3.19c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18.02c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75H3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineArrow2);
export default __webpack_public_path__ + "static/media/vuesax-outline-arrow-2.03e96d5288deca33d8fdba773cda367b.svg";
export { ForwardRef as ReactComponent };